import React, { FC, ReactNode, useMemo } from 'react';
import classnames from 'classnames';
import { WarningSolidIcon } from '@stpkg/stand-react';

export interface RSNoteProps {
  body: ReactNode;
  title?: string;
  variant?: 'basic' | 'caution' | 'capital';
}

export const RSNote: FC<RSNoteProps> = ({ body, title, variant = 'basic' }) => {
  const textColorClasses = useMemo(() => {
    switch (variant) {
      case 'basic':
      case 'caution':
        return ['text-gray-1000'];
      case 'capital':
        return ['text-red-700'];
    }
  }, [variant]);

  const iconFillClasses = useMemo(() => {
    switch (variant) {
      case 'basic':
        return [];
      case 'caution':
        return ['fill-yellow-400'];
      case 'capital':
        return ['fill-red-700'];
    }
  }, [variant]);

  return (
    <div className="rounded-10 bg-gray-10 box-border px-2 py-1.5">
      <div className="flex items-center">
        {variant !== 'basic' && (
          <div className="mr-1 flex-none">
            <WarningSolidIcon
              height="28"
              width="28"
              viewBox="0 0 48 48"
              className={classnames('block', iconFillClasses)}
            />
          </div>
        )}
        <div
          className={classnames(
            'rs-font',
            'text-16',
            'pc:text-15',
            textColorClasses,
          )}
        >
          {title && <div className="mb-0.5 font-bold">{title}</div>}
          <div className="whitespace-pre-wrap font-normal">{body}</div>
        </div>
      </div>
    </div>
  );
};
